'use client'
import { useState } from 'react'
import type { BrandGuidePdfProps } from '@sifly/shared-ui/brand/pdf'

export function DownloadBrandGuideButton({ pdf }: { pdf: BrandGuidePdfProps }) {
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(false)
  async function run() {
    setBusy(true); setErr(false)
    try {
      const { downloadBrandGuidePdf } = await import('@sifly/shared-ui/brand/pdf')
      await downloadBrandGuidePdf(pdf)
    } catch { setErr(true) } finally { setBusy(false) }
  }
  return (
    <div>
      <button type="button" onClick={run} disabled={busy}
        className="cta-primary inline-flex items-center px-5 py-2.5 text-sm font-medium rounded-md disabled:opacity-60">
        {busy ? 'Generating…' : 'Download brand guide (PDF)'}
      </button>
      {err && <p className="text-xs text-[var(--color-text-secondary)] mt-2">Couldn’t generate the PDF — please try again.</p>}
    </div>
  )
}
